import { UserRole } from '../../types/auth.types'

/**
 * 获取角色显示名称
 * @param role 角色字符串
 * @param t 可选的翻译函数 (i18next的t函数)
 * @returns 角色显示名称
 */
export function getRoleDisplayName(role: string, t?: (key: string, options?: any) => string): string {
  const defaultName = (roleStr: string) => {
    switch (roleStr) {
      case UserRole.SUPER_ADMIN:
        return '超级管理员'
      case UserRole.COMPANY_ADMIN:
        return '公司管理员'
      case UserRole.USER:
        return '普通用户'
      default:
        return '未知角色'
    }
  }

  if (t) {
    let translated = ''
    switch (role) {
      case UserRole.SUPER_ADMIN:
        translated = t('role.super_admin', { ns: 'common' })
        break
      case UserRole.COMPANY_ADMIN:
        translated = t('role.company_admin', { ns: 'common' })
        break
      case UserRole.USER:
        translated = t('role.regular_user', { ns: 'common' })
        break
      default:
        translated = t('role.unknown', { ns: 'common' })
        break
    }
    // 如果翻译结果仍然是键本身（未找到翻译），则回退到默认名称
    if (translated.startsWith('role.')) {
      return defaultName(role)
    }
    return translated
  }

  return defaultName(role)
}

/**
 * 获取角色对应的颜色
 * @param role 角色字符串
 * @returns Ant Design Tag组件的颜色
 */
export function getRoleColor(role: string): string {
  switch (role) {
    case UserRole.SUPER_ADMIN:
      return 'red'
    case UserRole.COMPANY_ADMIN:
      return 'orange'
    case UserRole.USER:
      return 'blue'
    default:
      return 'default'
  }
}

/**
 * 检查是否是管理员（超级管理员或公司管理员）
 * @param role 角色字符串
 * @returns 是否是管理员
 */
export function isAdminRole(role: string): boolean {
  return role === UserRole.SUPER_ADMIN || role === UserRole.COMPANY_ADMIN
}

/**
 * 检查是否是超级管理员
 * @param role 角色字符串
 * @returns 是否是超级管理员
 */
export function isSuperAdmin(role: string): boolean {
  return role === UserRole.SUPER_ADMIN
}

/**
 * 检查是否是公司管理员
 * @param role 角色字符串
 * @returns 是否是公司管理员
 */
export function isCompanyAdmin(role: string): boolean {
  return role === UserRole.COMPANY_ADMIN
}

/**
 * 检查是否是普通用户
 * @param role 角色字符串
 * @returns 是否是普通用户
 */
export function isRegularUser(role: string): boolean {
  return role === UserRole.USER
}